<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="callerRolesUpdated($event)">
  <div class="content-holder">
    <mat-toolbar color="accent" class="page-toolbar" [class.mobile]="mobileView">
      <mat-toolbar-row class="toolbar-row">
        <h1 i18n="Teachers List|Teachers List title@@teachers-list-title">Teachers</h1>

        <div class="fill-space"></div>

        <app-button label="Invite Teacher"
                    i18n-label="Teachers List|Invite Teacher button title@@teachers-list-invite-teacher-button-title"
                    color="primary"
                    [disabled]="!contest || !contestOpenForEnrol || (!region && allowRegionSelect)"
                    (clicked)="inviteTeacher(contest)"></app-button>
      </mat-toolbar-row>
    </mat-toolbar>

    <div class="content page">
      <mat-spinner *ngIf="!region && !allowRegionSelect" color="primary" diameter="30" class="center"></mat-spinner>
      <mat-accordion *ngIf="region || allowRegionSelect" class="filters-panel">
        <mat-expansion-panel [expanded]="!region || !school">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container *ngIf="region">{{region.name}}</ng-container>
              <ng-container *ngIf="!region && allowRegionSelect"
                            i18n="User Profile|School region select input label@@user-profile-school-region-select-input-label">Select Region</ng-container>
            </mat-panel-title>
            <mat-panel-description *ngIf="school">
              {{school.short_name || school.name}}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <school-select *ngIf="region || allowRegionSelect"
                         [roles]="roles"
                         [selectedRegion]="region"
                         [allowRegionSelect]="allowRegionSelect"
                         [allowSchoolSelect]="true"
                         [showGrade]="false"
                         [showSchool]="true"
                         [clearSchoolAfterSelect]="false"
                         [allowSchoolClear]="true"
                         [schoolRequired]="false"
                         (regionSelected)="handleRegionSelected($event)"
                         (schoolSelected)="handleSchoolSelected($event)"></school-select>
        </mat-expansion-panel>
      </mat-accordion>

      <contest-select-panel [competitionId]="competitionId"
                            [contest]="contest"
                            [mobileView]="mobileView"
                            (openForEnrolUpdated)="contestOpenForEnrol = $event"
                            (selected)="contestSelected($event)"></contest-select-panel>

      <mat-spinner *ngIf="competitionId && contest && region && !pendingRequests"
                   color="primary"
                   class="center"
                   diameter="30"></mat-spinner>
      <mat-accordion *ngIf="competitionId && contest && region && pendingRequests && pendingRequests.length > 0"
                     class="requests-panel">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <ng-container
                i18n="Teachers List|Pending teacher requests title@@teachers-list-pending-teacher-requests-title">
                Pending Teacher Requests
              </ng-container>
            </mat-panel-title>
            <mat-panel-description>
              <ng-container
                i18n="Teachers List|Pending teacher requests count title@@teachers-list-pending-teacher-requests-count-title">
                Requests count:
              </ng-container>
              {{pendingRequests.length}}
            </mat-panel-description>
          </mat-expansion-panel-header>

          <users-table [users]="pendingRequests"
                       [userRole]="TEACHER_ROLE"
                       [region]="region"
                       [school]="school"
                       [competitionId]="competitionId"
                       [contest]="contest"
                       [showLocation]="true"
                       [showPhone]="true"
                       [showSchool]="true"
                       [showApprove]="true"
                       (userRequestUpdated)="handleRequestUpdate($event)"></users-table>
        </mat-expansion-panel>
      </mat-accordion>


      <app-no-content *ngIf="!teachers && !inProgress && region"
                      [compact]="true"
                      title="Please select a contest from the list first"
                      i18n-title="Teachers List|Select contest prompt@@teachers-list-contest-prompt"
                      details="Teachers will be loaded for the selected region and contest"
                      i18n-details="Teachers List|Select contest prompt detail@@teachers-list-contest-prompt-detail">
      </app-no-content>
      <app-no-content *ngIf="!teachers && !inProgress && !region"
                      [compact]="true"
                      title="Please select a region from the list first"
                      i18n-title="Teachers List|Select region prompt@@teachers-list-region-prompt"
                      details="Teachers will be loaded for the selected region and contest"
                      i18n-details="Teachers List|Select contest prompt detail@@teachers-list-contest-prompt-detail">
      </app-no-content>
      <app-no-content *ngIf="teachers && !teachers.length"
                      [compact]="true"
                      title="Selected contest doesn't have any teachers assigned"
                      i18n-title="Teachers List|Selected contest no teachers title@@teachers-list-contest-no-teachers-title"
                      details="Try clearing filters if possible to load more results"
                      i18n-details="Teachers List|Selected contest no teachers detail@@teachers-list-contest-no-teachers-detail">

        <app-button label="Invite Teacher"
                    i18n-label="Teachers List|Invite Teacher button title@@teachers-list-invite-teacher-button-title"
                    color="primary"
                    class="center create-cta"
                    [disabled]="!contest || !contestOpenForEnrol || (!region && allowRegionSelect)"
                    (clicked)="inviteTeacher(contest)"></app-button>
      </app-no-content>

      <users-table *ngIf="competitionId && contest && teachers" #usersTable
                   [users]="teachers"
                   [userRole]="TEACHER_ROLE"
                   [region]="region"
                   [school]="school"
                   [competitionId]="competitionId"
                   [contest]="contest"
                   [editAllowed]="true"
                   [deleteAllowed]="true"
                   [showLocation]="true"
                   [showPhone]="true"
                   [showSchool]="true"
                   [showStatus]="true"
                   (deleteRequested)="removeTeacher($event, usersTable)"></users-table>

      <mat-spinner *ngIf="inProgress" color="primary" diameter="30" class="center"></mat-spinner>

      <div *ngIf="page && page.next_token" class="center-align">
        <app-link class="load-more-link"
                  label="load more"
                  icon="arrow_downward"
                  i18n-label="General|Load more action label@@general-load-more-action-label"
                  (click)="loadNextPage()"></app-link>
      </div>
    </div>
  </div>
</permission-checker>
